import React from 'react';

interface HashtagDisplayProps {
    hashtags: string[];
    className?: string;
}

export const HashtagDisplay: React.FC<HashtagDisplayProps> = ({ hashtags, className = '' }) => {
    if (!hashtags || hashtags.length === 0) {
        return null;
    }

    return (
        <div className={`flex flex-wrap gap-2 ${className}`}>
            {hashtags.map((hashtag, index) => (
                <span
                    key={index}
                    className="inline-flex items-center px-2 py-1 rounded-lg font-medium bg-transparent text-[#9BA1A8] border border-[#5F6775]" style={{ fontSize: '10px' }}
                >
                    #{hashtag}
                </span>
            ))}
        </div>
    );
}; 